/* global ADV */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const PAD_FOR_LEGEND = 'pad-for-legend';
export const NO_CONTENT = 'no-content';
export const HIGHLIGHT_SUBHEADER = 'highlight-subheader';
export const CAROUSEL = 'carousel';
export const NO_LINK = 'no-link';
export const EDIT_LINK = 'edit-link';
export const NO_CLICK = 'no-click';

const StyledCapsule = styled.div`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
  border-radius: ${props => props.theme.legacy.borderRadius};
`;

export default class Capsule extends Component {
  handleClick() {
    const { href, params, onClick, fpId, clientId } = this.props;

    if (!href) {
      return;
    }

    if (fpId) {
      ADV.consumer.setFPID(clientId, fpId);
    }

    if (!onClick) {
      ADV.util.Router.go2(href, params);
    } else {
      onClick.call();
    }
  }

  render() {
    const { header, subheader, hide, children, className, href } = this.props;

    const defaultClassName = `capsule ${!href ? 'no-link' : ''}`;

    return (
      <StyledCapsule className={`${defaultClassName} ${className || ''}`} isHidden={hide}>
        <h3 onClick={this.handleClick.bind(this)}>
          {header} {subheader}
        </h3>
        {children}
      </StyledCapsule>
    );
  }
}

Capsule.defaultProps = {
  hide: false,
  subheader: null,
};

Capsule.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  hide: PropTypes.bool,
  params: PropTypes.shape().isRequired,
  href: PropTypes.string.isRequired,
};
